import { render } from "./NoRules.vue?vue&type=template&id=ea7df202"
import script from "./NoRules.vue?vue&type=script&lang=js"
export * from "./NoRules.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__